export const transactionStatusColor: Record<string, string> = {
  SUCCESS: 'bg-status-completed',
  CONFIRMED: 'bg-status-neutral',
  UNCONFIRMED: 'bg-status-neutral',
  SCREENING_REQUESTED: 'bg-status-processing',
  PENDING_WHITELIST: 'bg-status-action-required',
  REJECTED: 'bg-status-negative',
  HELD: 'bg-status-action-required'
};

export const fallbackTransactionStatusColor = 'bg-status-neutral';
